import type { FaireProductEntity } from "../../entity_types/product";

export const p_9yeaw789js: FaireProductEntity = {
  token: "p_9yeaw789js",
  type: "product",
  name: "Pacific Row Plush Throw - Swell Blue",
  brandToken: "b_3ltt834j6o",
  brandName: "Sundream",
  imageUrl:
    "https://cdn.faire.com/fastly/0d14b762e86a483baa610a3c6217c50e7bf5e2c50351dbfd5bf524815aad8ef4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/822b9ca06f61630698d629ab20c2ca9bfaeeabd8c77ffc390b682b849275f696.png",
    "https://cdn.faire.com/fastly/d2832370d4167f50bd3117e3be52abdd2a0baa7c5bc97764797ab25e9f6cb22a.jpeg",
    "https://cdn.faire.com/fastly/616886407061bdb26f4d69bc1786dbcef52c3d7648a49a2fced3cabb241fb4cb.jpeg",
    "https://cdn.faire.com/fastly/62f9e065397d15535fcfd27b512caf2c4ea73654c948c21adafec61345fdc06d.jpeg",
  ],
  priceDollars: 34,
  description:
    "Introducing the newest and coziest blanket in the Sundream lineup: the DreamPlush Throw. These throws are like wrapping yourself in a cloud—soft, dreamy, and irresistibly plush. Whether you’re curling up on the couch or catching a sunset, the DreamPlush throws bring next-level comfort to every moment.\n\n• Unreal Softness: Made from 100% polyester, these throws feel like wrapping up in a tropical cloud.\n\n• Perfectly Sized: Generous 50” x 60” dimensions—big enough for couch snuggles, solo Netflix binges, or cozy backyard hangs.\n\n• Family Favorite: Kids adore them (seriously, they’ll steal yours). Once you try it, no other blanket compares.\n\n• Everyday Cozy: Great for indoor lounging or cozy evenings outside—your new go-to for any vibe.\n\n• So Many Options: You’ll want one for every room (and then some).",
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:30.907Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
